import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { FieldProps, getIn } from 'formik';
import { Grid } from '@mui/material';

import { FileInput } from '@styles/StyledTextField';
import { FileUploadTypography, UploadFileError, UploadFileWrapper } from '@styles/Tools/FileUpload/FileUploadStyles';
import { colorTheme, muiTheme } from '@styles/muiTheme';
import { LoadingButton } from '@shared/inputs/Buttons';


const ACCEPTED_FILES = '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';

interface IFileUploadProps extends FieldProps {
  onFileChange?: (acceptedFiles: File) => void;
}

export const FileUpload = ({ field, form, onFileChange }: IFileUploadProps) => {
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState('');
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const handleFiles = useCallback(async(event: ChangeEvent<HTMLInputElement>) => {
    setLoading(true);
    const fileList = event.target.files || {};
    const files: File[] = Object.values(fileList);

    if (files) {
      form.setFieldValue(field?.name, files[0]);
      setFileName(files[0]?.name);
    }
    if (onFileChange) onFileChange(files[0]);
    setLoading(false);
  }, []);

  const borderColor = useMemo(() => {
    return touched &&
      error ? `1px solid ${muiTheme.palette.error.main}`
      : `1px solid ${colorTheme.palette.grey[500]}`;
  }, [touched, error]);

  return (
    <div>
      <UploadFileWrapper bordercolor={borderColor}>
        <Grid container spacing={2}>
          <Grid item xs={6} lg={4}>
            <LoadingButton
              sx={{ whiteSpace: 'nowrap', width: '100%' }}
              loading={loading}
              loadingIndicator="Uploading..."
              variant="contained"
              component="label"
            >
              Select File...
              <FileInput type={'file'} inputProps={{ accept: ACCEPTED_FILES }} onChange={handleFiles} />
            </LoadingButton>
          </Grid>
          <Grid item xs={6} lg={8}>
            <FileUploadTypography variant="subtitle1">   
              {fileName} 
            </FileUploadTypography>
          </Grid>
        </Grid>
      </UploadFileWrapper>
      <UploadFileError>{touched && error}</UploadFileError>
    </div>
  );
};
